import { render, staticRenderFns } from "./SingleLayerCoupe.vue?vue&type=template&id=5b61f208&scoped=true"
import script from "./SingleLayerCoupe.vue?vue&type=script&lang=ts"
export * from "./SingleLayerCoupe.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style1 = require("./SingleLayerCoupe.vue?vue&type=style&index=1&id=5b61f208&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b61f208",
  null
  ,true
)

export default component.exports